import { FETCH_POPULAR_LIST, FETCH_POPULAR_LIST_START, FETCH_POPULAR_LIST_ERROR } from "../constants/ActionTypes";

const INITIAL_STATE = {
  isLoading: false,
  hasError: false,
  items: null,
};

export default function popularListReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_POPULAR_LIST_START:
      return { ...state, isLoading: true, hasError: false };
    case FETCH_POPULAR_LIST:
      return { ...state, items: action.payload, isLoading: false, hasError: false };
    case FETCH_POPULAR_LIST_ERROR:
      return { ...state, isLoading: false, hasError: true };
    default:
      return state;
  }
}
